import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Response } from '../interfaces/response.interface';
import { map } from 'rxjs/operators';
import { ColumnAlias } from '../+state/column-aliases/interfaces/column-alias.interface';
import { ApiUrlService } from './api-url.service';

@Injectable()
export class ColumnsAliasesService {
  private _url = `${this._apiService.apiUrl}/investigator/varmap`;

  constructor(
    private _http: HttpClient,
    private _apiService: ApiUrlService,
  ) {}

  public getColumnsAliases(): Observable<ColumnAlias[]> {
    const params = {
      'per-page': 1000,
      page: 1,
    };

    return this._http.get<Response<ColumnAlias[]>>(this._url, { params })
      .pipe(
        map(response => response.data.map(columnAlias => columnAlias)),
      );
  }

  public createAlias(attribute: string, alias: string): Observable<unknown> {
    const params = { attribute, alias };
    return this._http.post<Response<ColumnAlias[]>>(this._url, { ...params })
  }

  public editAlias(id: string, attribute: string, alias: string): Observable<ColumnAlias> {
    const url = `${this._url}/${id}`;
    const params = { alias };

    return this._http.patch<Response<ColumnAlias>>(url, { ...params }).pipe(
      map(response => response.data),
    );
  }

  public deleteAlias(id: string): Observable<unknown> {
    const url = `${this._url}/${id}`;

    return this._http.delete(url);
  }
}
